<template lang="pug">
#wrap_sub
  .sub_right
    .content_desc
      #s41.sub
        .in
          h2(class='s_tit')
            span NEWS
          .total_board_list_wrap
            .board_category_tab
              nav#bo_cate
                h2 NEWS 카테고리
                ul#bo_cate_ul
                  li
                    a(@click='getData(0)' :id='[cat == 0 ? "bo_cate_on" : ""]') 전체
                  li
                    a(@click='getData(2)' :id='[cat == 2 ? "bo_cate_on" : ""]') 공지사항
                  li
                    a(@click='getData(1)' :id='[cat == 1 ? "bo_cate_on" : ""]') 보도자료
            .board_top
              .in
                ul.gallery77
                  li(v-for="res in resData.data" :key="res.idx")
                    a
                      .square_img
                        .image
                          img(:src='res.file_path' @click='$_goTo({name: "detail-news", params: {id: res.idx}})')
                      ul.info(@click='$_goTo({name: "detail-news", params: {id: res.idx}})')
                        li.cago [ {{res.category}} ]
                        li.subject {{res.title}}
                        li.content(v-html="res.content")
                        li.date {{res.date}}
                  li(v-if="resData.leng == 0")
                    p 게시물이 없습니다.
                  
            nav.pg_wrap(v-if="resData.data.length !== 0")
              span.pg
                a.pg_page.pg_start(@click='selectPage("prev")' v-if="resData.paging[2]")
                a.pg_page(v-for="(num, id) in pageNumber" :key="id" @click='selectPage(num)' :class='[page == num ? "pg_current" : ""]') {{num}}
                a.pg_page.pg_end(@click='selectPage("next")' v-if="resData.paging[3]")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      cat: 0,
      resData: {
        leng: 0,
        data: [],
        paging: [],
      },
      checked: [],
      page: '',
      pageNumber: [],
    };
  },
  computed: {
    ...mapGetters(['lan', 'newsPage']),
  },
  methods: {
    ...mapActions(['savePage']),
    async getData(cat) {
      if (cat !== undefined) {
        this.cat = cat;
        this.page = 1;
      }
      this.page == '' ? (this.page = 1) : null;

      await this.$_axios('GET', 'board/news/list', {
        page: this.page,
        category: this.cat,
        nation: this.lan,
      }).then(res => {
        this.resData.data = res.data.res[0];
        this.resData.leng = this.resData.data.length;
        this.resData.paging = res.data.res[1];
        this.pageNumber = new Array(
          this.resData.paging[1] + 1 - this.resData.paging[0],
        )
          .fill(this.resData.paging[0])
          .map((n, i) => n + i);
      });
    },
    selectPage(num) {
      if (num == 'prev') {
        this.page = this.resData.paging[0] - 1;
      } else if (num == 'next') {
        this.page = this.resData.paging[1] + 1;
      } else {
        this.page = num;
      }
      this.savePage(['news', num]);
      this.getData();
    },
  },
  mounted() {
    if (this.newsPage !== 0) {
      this.page = this.newsPage;
    }
    this.savePage(['store', 0]);
    this.savePage(['news', 0]);
    this.getData();
  },
};
</script>
<style>
/* @import '../../assets/css/news_board.css'; */
.check {
  display: flex;
}
.check input {
  margin-top: 5px;
}
.check li {
  margin-left: 5px;
}
</style>
